import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import ChatWindow from "@/components/chat/ChatWindow";

interface ChatModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

export const ChatModal: React.FC<ChatModalProps> = ({ isOpen, onClose, title }) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    } else {
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed bottom-24 right-8 z-50">
      <div
        className="relative bg-white rounded-2xl shadow-xl w-100 h-[76vh] flex flex-col" // Added flex flex-col, removed overflow-y-auto
        role="dialog"
        aria-modal="false"
        aria-labelledby="modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex rounded-t-xl bg-gradient-to-br from-slate-600 via-blue-600 to-slate-600 text-white justify-between items-center p-4 border-b border-gray-300">
          <h3 id="modal-title" className="text-lg font-semibold ">{title}</h3>
          <button
            onClick={onClose}
            className="hover:text-gray-400 transition-colors"
            aria-label="Close modal"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        {/* ChatWindow will now take up the remaining flexible space */}
        <div className="flex-1 overflow-hidden">
          <ChatWindow />
        </div>
      </div>
    </div>,
    document.body
  );
};
